import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
export function GuideSelect({ selectedGuideIds, onChange }) {
    const { data: users = [], isLoading } = useQuery({
        queryKey: ['guide-users'],
        queryFn: async () => {
            const { data } = await fetch(`${import.meta.env.VITE_API_URL ?? 'http://localhost:3001'}/api/v1/users?role=GUIDE`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('gv-auth') ?? '{}')?.state?.accessToken ?? ''}`,
                },
            }).then((r) => r.json());
            return data;
        },
        staleTime: 5 * 60 * 1000,
    });
    const toggleGuide = (userId) => {
        if (selectedGuideIds.includes(userId)) {
            onChange(selectedGuideIds.filter((id) => id !== userId));
        }
        else {
            onChange([...selectedGuideIds, userId]);
        }
    };
    if (isLoading) {
        return (_jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("p", { className: "input-label", children: "Asignar gu\u00EDas" }), Array.from({ length: 3 }).map((_, i) => (_jsx("div", { className: "h-10 rounded-md animate-pulse bg-[var(--color-surface-raised)]" }, i)))] }));
    }
    if (users.length === 0) {
        return (_jsx("div", { className: "p-4 text-sm text-[var(--color-text-muted)] text-center border border-dashed border-[var(--color-border)] rounded-md", children: "No hay gu\u00EDas disponibles" }));
    }
    return (_jsxs("div", { className: "flex flex-col gap-2", children: [_jsxs("p", { className: "input-label", children: ["Asignar gu\u00EDas (", selectedGuideIds.length, " selected)"] }), _jsx("div", { className: "flex flex-col gap-1.5 max-h-48 overflow-y-auto border border-[var(--color-border)] rounded-md p-2", children: users.map((user) => {
                    const isSelected = selectedGuideIds.includes(user.id);
                    return (_jsxs("label", { className: `flex items-center gap-2 p-2 rounded cursor-pointer transition-colors ${isSelected
                            ? 'bg-[var(--tenant-primary)]/10 border border-[var(--tenant-primary)]/30'
                            : 'hover:bg-[var(--color-surface-raised)]'}`, children: [_jsx("input", { type: "checkbox", checked: isSelected, onChange: () => toggleGuide(user.id), className: "w-4 h-4 rounded border-[var(--color-border)]" }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("p", { className: "text-sm font-medium text-[var(--color-text)] truncate", children: user.name }), _jsx("p", { className: "text-xs text-[var(--color-text-muted)] truncate", children: user.email })] })] }, user.id));
                }) })] }));
}
//# sourceMappingURL=GuideSelect.js.map